{
  "secret_key": "fWxU6zjVjCA8XHLthhy7BxLr9WsVbC",
  "shop": "limbaechershop.myshopify.com",
  "app_url": "/apps/purreq/"
}
